<template>
  <div>
    <div class="box">
      <div class="div1">
         <span>班级名称：{{classSignInfo.trainClassName}}</span>
      </div>
      <div class="div2">
         <span>负责老师：{{classSignInfo.teacherName}}</span>
      </div>
      <div class="div3">
         <span>有效期间：{{classSignInfo.classDate}}</span>
      </div>
      <div class="div4">
         <span>总学员：{{classSignInfo.studentTotalNum}}人</span>
      </div>
    </div>


    <div class="box2">
      <BInputDate 
        labelText = "签到日期" 
        placeholder = "请选择日期"
        :required="true"
        v-model="signDate"
        @dateChange="onDateTimeChange"
      />
      <BInputPullDown
        label-name="签到期间"
        v-model="signPeriod"
        :Options="signPeriodList"
        :placeholder="signPeriod"
        :disabled="true"
      />
      <BInputPullDown
        label-name="状态"
        v-model="signStatus"
        :Options="signStatusList"
        placeholder="全部"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
      <BBtnPrimary
        :img-src="require('@/assets/professional.png')"
        :clicked="downloadExcel"
        btn-txt="下载"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-functions">
        </div>
        <div class="search-result-summary">
          <div class="summary">已签到：{{studentSignNum}}人</div>
          <div class="summary">未签到：{{studentUnSignNum}}人</div>
          <div class="summary">签到率：{{signRate}}%</div>
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="pageList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
              <template v-slot:actions="item">
                  <div v-if="item.data.signStatus === '0' && classStatus !== '03'" 
                     style="display: flex; flex-direction: row; justify-content: center">
                    <div
                      class="btn-detail"
                      @click="doSignIn(item.data.studentId,item.data.idPhotoUrl)"
                    >
                      签到
                    </div>
                  </div>

                  <div
                    v-else
                    style="display: flex; flex-direction: row; justify-content: center"
                  >
                    --
                  </div>
              </template>
      </Table>
    </div>
  </div>
</template>
<script>
import { searchInit,searchList,getClassSignDetail,addStudentSign,getSignList } from "@/api/studentSign";
import BInputPullDown from "../../components2/BInputPullDown";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Table from "../../components2/Table";
import BInputDate from "../../components2/BInputDate";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Vue from "vue";
export default {
  name: "CourseManagement",
  components: {
    Table,
    BInputPullDown,
    BBtnSecondary,
    BInputDate,
    BBtnPrimary,
  },
  data: () => ({
    limitList: [
      {
        value: 10,
        text: "10条/页",
      },
      {
        value: 20,
        text: "20条/页",
      },
      {
        value: 30,
        text: "30条/页",
      },
    ],
    id: 0,
    pageNum: 1,
    limit: 10,
    pageCount: 10,
    totalCount: 0,
    studentTotalNum: 0,
    timeout: 3000,
    snackbarColor: "",
    snackbarText: "",
    totalPages: 0,
    page: 1,
    dropdownData: [
      {name: "手动添加"},
      {name: "批量导入"},
    ],
    userName: "",
    idCard: "",
    telNo: "",
    className: "",
    data: {},
    selected: [],
    singleSelect: false,
    loading: false,
    snackbar: false,
    snackbarObj: {
      snackbar: false,
      timeout: -1,
      color: "",
      text: "",
    },
    headers: [
      { text: "ID", value: "indexNum", sortable: false, align: "center", width: '5%' },
      { text: "姓名", value: "studentName", sortable: false, align: "center", width: '18%' },
      { text: "性别", value: "sex", sortable: false, align: "center", width: '18%' },
      { text: "电话", value: "telNo", sortable: false, align: "center", width: '18%' },
      { text: "签到时间", value: "signInTime", sortable: false,align: "center", width: '20%' },
      { text: "操作", value: "actions", sortable: false, align: "center" },
    ],
    pageList: [],
    deleteDialog: false,
    deleteDialogFlag: false,
    classNum: "",
    deleteId: "",
    classId: "",
    signPeriod: "",
    classSignInfo: {
      trainClassName: '',
      teacherName: '',
      classDate: '',
      studentTotalNum: '',
    },
    navi: [{ name: "class-management" },{ name: "class_student_sign_list" }],
    searchParam: {},
    signPeriodList: [],
    signStatusList: [],
    startDate: '',
    endDate: '',
    signDate: '',
    signPeriodText: '',
    signStatus: '',
    classStatus: '',
    studentSignNum: '0',
    studentUnSignNum: '0',
    signRate: '100',
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = {
        classId: vm.$route.params.classId,
        signPeriod: vm.$route.params.signPeriod,
        classStatus: vm.$route.params.status,
      };
      if (
        params.classId !== null &&
        params.classId !== "" &&
        params.classId !== undefined &&
        params.signPeriod !== null &&
        params.signPeriod !== "" &&
        params.signPeriod !== undefined &&
        params.classStatus !== null &&
        params.classStatus !== "" &&
        params.classStatus !== undefined
      ) {
        // 把不为空的参数存入缓存
        vm.$store.commit("SET_ClASS_STUDENT_SIGN_PARAMS", params);
      }
      // 查询条件赋值
      if (
        vm.$store.state.studentSign_classId !== undefined &&
        vm.$store.state.studentSign_classId !== null &&
        vm.$store.state.studentSign_classId !== "" 
      ) {
        vm.classId = vm.$store.state.studentSign_classId;
        vm.signPeriod = vm.$store.state.studentSign_signPeriod;
        vm.classStatus = vm.$store.state.studentSign_classStatus;
      }

      if (
        vm.classId !== undefined &&
        vm.classId !== null &&
        vm.classId !== "" &&
        vm.signPeriod !== undefined &&
        vm.signPeriod !== null &&
        vm.signPeriod !== ""
      ) {
        
        vm.searchInit();
      }
    });
  },
  beforeMount() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
  },
  methods: {
    async searchInit() {
      var param = {
        trainClassId: this.classId,
      };
      const data = await searchInit(param);
      this.signPeriodList = data.data.signPeriodList;
      this.signStatusList = data.data.signStatusList;
      if(this.signDate=="" || this.signDate ==undefined ){
        this.signDate = data.data.nowDateStr;
      }
      if (
        this.$store.state.studentSign_signPeriod !== undefined &&
        this.$store.state.studentSign_signPeriod !== null &&
        this.$store.state.studentSign_signPeriod !== ""
      ) {
        this.signPeriod = this.$store.state.studentSign_signPeriod;
      }

      this.searchList();
      this.getClassSignDetail();
    },
    doSearch(flag) {
      if (flag) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 10;
      }
      this.searchList();
    },
    async getClassSignDetail() {
      this.startDate = this.signDate+" "+this.signPeriod.split('-')[0];
      this.endDate = this.signDate+" "+this.signPeriod.split('-')[1];
      var param = {
        trainClassId: this.classId,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      const data = await getClassSignDetail(param);
      if (data.data != null || data.data === "") {
        this.classSignInfo = data.data
      }
    },
    async searchList() {
      this.startDate = this.signDate+" "+this.signPeriod.split('-')[0];
      this.endDate = this.signDate+" "+this.signPeriod.split('-')[1];
      var param = {
        page: this.page,
        limit: this.limit,
        trainClassId: this.classId,
        startDate: this.startDate,
        endDate: this.endDate,
        signStatus: this.signStatus
      };
      const data = await searchList(param);
      this.studentSignNum = data.data.studentSignNum
      this.studentUnSignNum = data.data.studentUnSignNum
      this.signRate = data.data.signRate
      if (data.data.searchList != null || data.data.searchList === "") {
        this.pageList = data.data.searchList;
      }
      this.totalCount = data.data.totalPage;
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
    },
    onDateTimeChange(value) {
      this.signDate = value
      this.searchList()
    },
    // 下载报表
    async downloadExcel(){
      if(this.pageList.length === 0){
         Vue.prototype.$valertbar.show("暂无数据无法下载");
         return false
      }
      this.startDate = this.signDate+" "+this.signPeriod.split('-')[0];
      this.endDate = this.signDate+" "+this.signPeriod.split('-')[1];
      var param = {
        trainClassId: this.classId,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      const data = await getSignList(param);
      if (data.code === 1) {
        window.location.href =
          process.env.VUE_APP_BASE_API+'/downSignExcel?trainClassId='+this.classId+'&startDate='+this.startDate+'&endDate='+this.endDate
      }else{
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    doSignIn(studentId,photoUrl){
      this.startDate = this.signDate+" "+this.signPeriod.split('-')[0];
      this.endDate = this.signDate+" "+this.signPeriod.split('-')[1];
      this.saveSign(studentId,photoUrl,this.startDate,this.endDate);
    },
    async saveSign(studentId,photoUrl,startDate,endDate){
      var param = {
        studentId: studentId,
        trainClassId: this.classId,
        idPhotoUrl: photoUrl,
        signDate: this.signDate,
        startDate: startDate,
        endDate: endDate,
      };
      const data = await addStudentSign(param);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show("签到成功");
        this.searchInit()
      } else if(data.code === -1){
        Vue.prototype.$valertbar.show("当前时间不在签到期间内，无法签到");
      } else {
        Vue.prototype.$valertbar.show("签到失败");
      }
    }
  },
  destroyed() {
  },
  mounted() {
  },
};
</script>

<style scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*top: 0;*/
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  margin: 0 10px 0 20px;
  color: #fd1f58;
  cursor: pointer;
}

.div1{
  width: 300px;
  height: 20px;
}

.div2{
  width: 300px;
  height: 20px;
  padding-left: 10px;
}

.div3{
  width: 300px;
  height: 20px;
  margin-left: 10px;
  padding-left: 10px;
}

.div4{
  width: 300px;
  height: 20px;
  margin-left: 40px;
  padding-left: 20px;
}

.box2 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 30px;
  margin-top: 20px;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}

.btn-reset {
  margin: 0 10px 0 10px;
  color: #0171a3;
  cursor: pointer;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}
</style>
